/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiSegmentEventType {
    FULL_CALCULATION_STARTED = 'FULL_CALCULATION_STARTED',
    FULL_CALCULATION_CHECKPOINT_REACHED = 'FULL_CALCULATION_CHECKPOINT_REACHED',
    FULL_CALCULATION_FINISHED = 'FULL_CALCULATION_FINISHED',
    FULL_CALCULATION_FAILED = 'FULL_CALCULATION_FAILED',
    SINGLE_CALCULATION_FAILED = 'SINGLE_CALCULATION_FAILED'
}


export function instanceOfInternalApiSegmentEventType(value: any): boolean {
    for (const key in InternalApiSegmentEventType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiSegmentEventType, key)) {
            if (InternalApiSegmentEventType[key as keyof typeof InternalApiSegmentEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiSegmentEventTypeFromJSON(json: any): InternalApiSegmentEventType {
    return InternalApiSegmentEventTypeFromJSONTyped(json, false);
}

export function InternalApiSegmentEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSegmentEventType {
    return json as InternalApiSegmentEventType;
}

export function InternalApiSegmentEventTypeToJSON(value?: InternalApiSegmentEventType | null): any {
    return value as any;
}

export function InternalApiSegmentEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiSegmentEventType {
    return value as InternalApiSegmentEventType;
}

